export default {
  loading: false,
  receivedEmails: [],
  selectedEmail: null,
  showEmailViewer: false,
  page: 1,
  pages: 1,
  itemsPerPage: 10,
  filters: {}
};
